import React from "react";
import "./component-css/LearningMaterials.css";

const Resources = () => {
    const tutorials = [
        {
            title: "Welcome to the Discourse 1Future Platform",
            file: "/videos/WELCOME.mp4"
        },
        {
            title: "How to create an account?",
            file: "/videos/Tutorial2.mp4"
        },
        {
            title: "How to login and customize your profile?",
            file: "/videos/Tutorial1.mp4"
        },
        {
            title: "Categories and groups",
            file: "/videos/categories&groups.mp4"
        }
    ];

    return (
        <div className="content-page lm-page">
            <header className="lm-header">
                <h1 className="lm-title">Tutorials &amp; Resources</h1>
                <p className="lm-subtitle">
                    Step-by-step video guides to help you get started and make the
                    most of the 1FUTURE platform.
                </p>
            </header>

            <div className="lm-list">
                {tutorials.map((t, index) => (
                    <div key={index} className="lm-card lm-video-card">
                        <div className="lm-video-head">
                            <span className="lm-video-badge" aria-hidden="true">▶</span>
                            <h3 className="lm-card-title">{t.title}</h3>
                        </div>

                        <div className="lm-video-frame">
                            <video className="lm-video" controls preload="metadata">
                                <source src={t.file} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Resources;
